// removed by extract-text-webpack-plugin
module.exports = {"loading":"client-components-Spinner-styles__loading___35hlr","spinner":"client-components-Spinner-styles__spinner___3EGSq"};


//////////////////
// WEBPACK FOOTER
// ./client/components/Spinner/styles.css
// module id = 405
// module chunks = 0